module.exports = __webpack_public_path__ + "img/logo.bee0c3be.png";